<template>
  <div class="terms" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <h1>スクワットロッカー利用規約</h1>
    <p>「スクワットロッカー 利用規約」（以下、「本規約」といいます。）は、メノア株式会社（以下、「当社」といいます。）が提供するアプリ「スクワットロッカー」（以下、「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用するお客様（以下、「ユーザー」といいます。）には、本規約に従って本サービスをご利用いただきます。</p>

    <h2>第1条 適用</h2>
    <p>本規約は、ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。</p>

    <h2>第2条 契約の成立</h2>
    <p>ユーザーが本サービスをスマートフォンやその他の情報端末にダウンロードした時点で本規約に同意したものとみなし、当社とユーザーとの間で本サービスの提供にかかる契約（以下、「本契約」といいます。）が成立します。</p>

    <h2>第3条 本規約の変更</h2>
    <ul>
      <li>当社は、必要に応じて本規約の内容を変更することができるものとします。変更後の規約は、本サービス上または当社のウェブサイトへの掲載により告知します。</li>
      <li>ユーザーが本規約の変更後も本サービスの利用を継続する場合、変更後の規約に同意したものとみなされます。</li>
    </ul>

    <h2>第4条 本サービスの内容</h2>
    <ul>
      <li>本サービスは、スクワットのカウント機能および運動記録の管理機能を提供するアプリです。</li>
      <li>本サービスは会員登録不要でご利用いただけます。ユーザーのデータはユーザーのデバイス内にのみ保存され、当社のサーバーには送信されません。</li>
      <li>本サービスは、ユーザーが私的に使用する目的でのみ利用することができます。</li>
      <li>当社は、ユーザーに通知することなく、本サービスの内容を変更し、または本サービスの提供を中止することができるものとします。</li>
    </ul>

    <h2>第5条 利用料金</h2>
    <ul>
      <li>本サービスは無料のサービスおよび、定額料金制（金額はプランによって異なります。）の有料サービスがあります。以下、定額料金を「利用料金」といいます。</li>
      <li>利用料金は、当社の定める手続きにより事前告知なく改定する場合があります。</li>
      <li>利用料金は、App Store・Google Play等のプラットフォームを通じてお支払いいただきます。なお、支払に要する費用は、ユーザーの負担とします。</li>
      <li>利用料金の支払いに関し、ユーザーとApp Store・Google Play等のプラットフォームとの間で紛争が生じた場合は、ユーザーの責任と費用負担においてこれを解決していただくものとし、当社は一切責任を負わないものとします。</li>
    </ul>

    <h2>第6条 注意事項</h2>
    <ul>
      <li>本サービスが提供する情報は、一般的な運動に関する参考情報であり、医学的判断を行うものではありません。</li>
      <li>運動を行う際は、ご自身の体調や健康状態を考慮し、必要に応じて医療機関にご相談ください。</li>
    </ul>

    <h2>第7条 免責事項</h2>
    <ul>
      <li>当社は、本サービスにより提供する情報の完全性、正確性、有用性等を保証するものではありません。</li>
      <li>本サービスの利用により生じた損害について、当社は一切の責任を負いません。</li>
      <li>デバイスの故障、機種変更等によりデータが消失した場合、当社は復旧の責任を負いません。</li>
    </ul>

    <h2>第8条 著作権</h2>
    <p>本サービスにより提供されるコンテンツ、サービス、技術などの情報は、著作権等の知的財産権関連法令で保護されています。ユーザーは、当該情報を私的利用の範囲内でのみ利用できます。</p>

    <h2>第9条 禁止事項</h2>
    <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
    <ul>
      <li>法令または公序良俗に違反する行為</li>
      <li>本サービスの運営を妨害する行為</li>
      <li>本サービスのリバースエンジニアリングその他ソースコードを解析する行為</li>
      <li>その他、当社が不適切と判断する行為</li>
    </ul>

    <h2>第10条 本サービスの利用終了</h2>
    <p>ユーザーは、本サービスをアンインストールすることで、いつでも本サービスの利用を終了することができます。アンインストールにより、デバイス内に保存されたデータは削除されます。</p>

    <h2>第11条 準拠法・裁判管轄</h2>
    <ul>
      <li>本規約の解釈にあたっては、日本法を準拠法とします。</li>
      <li>本サービスに関して紛争が生じた場合には、東京地方裁判所または東京簡易裁判所を専属的合意管轄とします。</li>
    </ul>

    <p>2025年2月3日制定</p>
  </div>
</template>

<script>
export default {
  name: 'SquatLockerTermsView',
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    document.title = '利用規約 | スクワットロッカー';
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped>
/* 共通スタイル - 見出し設定 */
h1 {
  color: var(--color-green-600);
}

h2 {
  font-size: 20px;
  color: var(--color-grey-500);
  margin-top: 32px;
}

p, li {
  color: var(--color-grey-500);
}

/* モバイル対応スタイル */
.mobile {
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 24px;
  padding-right: 24px;
}

.mobile h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.mobile h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 16px;
}

.mobile p, .mobile li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.mobile ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.mobile li {
  margin-bottom: 5px;
}

/* デスクトップ対応スタイル */
.desktop {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 80px;
  padding-right: 80px;
  max-width: 1120px;
  margin: 0 auto;
}

.desktop h1 {
  font-size: 28px;
  padding-bottom: 24px;
  text-align: left;
}

.desktop h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 24px;
}

.desktop p, .desktop li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.desktop ul {
  margin-bottom: 20px;
  padding-left: 20px;
}

.desktop li {
  margin-bottom: 8px;
}
</style>
